import { Instagram, Facebook, Music2, Mail, Phone, MapPin } from "lucide-react";
import { BRAND, SOCIAL, NAV_LINKS, whatsappUrl } from "../data/content";

const SOCIAL_LINKS = [
    { Icon: Instagram, url: SOCIAL.instagram, label: "Instagram" },
    { Icon: Facebook, url: SOCIAL.facebook, label: "Facebook" },
    { Icon: Music2, url: SOCIAL.tiktok, label: "TikTok" },
];

export const Footer = () => {
    const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

    return (
        <footer
            data-testid="footer"
            className="relative overflow-hidden border-t border-gold/30 bg-[hsl(var(--card))] pt-20 pb-8"
        >
            {/* top gold shimmer */}
            <div className="pointer-events-none absolute left-0 right-0 top-0 h-[2px] animate-shimmer" />

            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="grid grid-cols-1 gap-12 md:grid-cols-4">
                    {/* Brand */}
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-3">
                            <div className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-gold">
                                <span className="font-display text-xl text-gold">M</span>
                            </div>
                            <div>
                                <div className="font-display text-lg text-foreground">Mariachi</div>
                                <div className="font-display text-sm tracking-[0.25em] text-gold">
                                    MEXICANÍSIMO
                                </div>
                            </div>
                        </div>
                        <p className="mt-5 max-w-md text-sm leading-relaxed text-muted-foreground">
                            Serenatas que enamoran y alegran el corazón del Eje Cafetero.
                            Mariachis profesionales en Armenia, Quindío, disponibles 24/7
                            para eventos, cumpleaños, aniversarios y fechas especiales.
                        </p>
                        <div className="mt-6 flex gap-3">
                            {SOCIAL_LINKS.map(({ Icon, url, label }, i) => (
                                <a
                                    key={label}
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-gold/40 text-gold transition hover:border-gold hover:bg-gold hover:text-black"
                                    aria-label={label}
                                    data-testid={`footer-social-${i}`}
                                >
                                    <Icon className="h-4 w-4" />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Nav */}
                    <div>
                        <h4 className="font-serif-pf text-sm uppercase tracking-[0.25em] text-gold">
                            Navegación
                        </h4>
                        <ul className="mt-5 space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.id}>
                                    <button
                                        onClick={() => go(l.id)}
                                        data-testid={`footer-nav-${l.id}`}
                                        className="text-sm text-muted-foreground transition hover:text-gold"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-serif-pf text-sm uppercase tracking-[0.25em] text-gold">
                            Contacto
                        </h4>
                        <ul className="mt-5 space-y-4 text-sm">
                            <li className="flex items-start gap-3 text-muted-foreground">
                                <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-gold" />
                                {BRAND.city}, {BRAND.country}
                            </li>
                            <li>
                                <a
                                    href={`tel:+57${BRAND.phone}`}
                                    className="flex items-start gap-3 text-muted-foreground hover:text-gold"
                                >
                                    <Phone className="mt-0.5 h-4 w-4 flex-shrink-0 text-gold" />
                                    {BRAND.phoneDisplay}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`mailto:${BRAND.email}`}
                                    className="flex items-start gap-3 break-all text-muted-foreground hover:text-gold"
                                >
                                    <Mail className="mt-0.5 h-4 w-4 flex-shrink-0 text-gold" />
                                    {BRAND.email}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-gold/20 pt-8 md:flex-row">
                    <p className="text-xs text-muted-foreground">
                        © {new Date().getFullYear()} {BRAND.name}. Todos los derechos reservados.
                    </p>
                    <p className="font-serif-pf text-xs text-muted-foreground">
                        Hecho con pasión mexicana en el corazón del Eje Cafetero.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
